import React from "react";
import { fmtDateLong } from "@/lib/format";
import { Badge } from "@/components/Badge";
import { FESTIVAL_CATEGORY, FESTIVAL_FAITH } from "@/lib/meta";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { AlertTriangle, CheckCircle2, Circle, CalendarPlus } from "lucide-react";

export function FestivalDetail({ fest, onClose, onPlan }) {
  if (!fest) return null;
  return (
    <Dialog open={!!fest} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-w-lg" data-testid="festival-detail-dialog">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-3 font-heading">
            <span className="text-3xl">{fest.emoji}</span>
            <div>
              <div>{fest.name}</div>
              <div className="mt-0.5 text-xs font-normal text-zinc-500">{fmtDateLong(fest.date)}</div>
            </div>
          </DialogTitle>
        </DialogHeader>
        <div className="space-y-4 py-1">
          <div className="flex flex-wrap gap-1.5">
            <Badge color={FESTIVAL_CATEGORY[fest.category]?.color || "grey"}>{FESTIVAL_CATEGORY[fest.category]?.label || fest.category}</Badge>
            {fest.faith && fest.faith !== "secular" && <Badge color={FESTIVAL_FAITH[fest.faith]?.color || "grey"}>{FESTIVAL_FAITH[fest.faith]?.label}</Badge>}
            <Badge color="grey">{fest.region}</Badge>
            <Badge color={fest.days_remaining <= 7 ? "red" : fest.days_remaining <= 21 ? "orange" : "blue"}>{fest.days_remaining}d remaining</Badge>
          </div>
          {fest.variable && (
            <div className="flex items-start gap-2 rounded-md border border-amber-200 bg-amber-50 px-3 py-2 text-xs text-amber-800" data-testid="festival-variable-note">
              <AlertTriangle className="mt-0.5 h-3.5 w-3.5 shrink-0" />
              <span>Date is subject to moon-sighting / local panchang confirmation and may shift by a day.</span>
            </div>
          )}
          <div>
            <div className="mb-2 text-xs font-semibold uppercase tracking-wide text-zinc-400">Content Planning — Your Clients</div>
            {fest.total_clients === 0 ? (
              <div className="rounded-md border border-zinc-100 bg-zinc-50 px-3 py-3 text-center text-xs text-zinc-400">No assigned clients to plan for.</div>
            ) : (
              <div className="max-h-52 space-y-1 overflow-y-auto">
                {fest.coverage.map((c) => (
                  <div key={c.client_id} className="flex items-center justify-between rounded-md border border-zinc-100 px-3 py-2 text-sm" data-testid={`coverage-${c.client_id}`}>
                    <span className="truncate text-zinc-800">{c.client_name}</span>
                    {c.planned ? (
                      <span className="flex items-center gap-1 text-xs font-medium text-emerald-600"><CheckCircle2 className="h-3.5 w-3.5" />Planned</span>
                    ) : (
                      <span className="flex items-center gap-1 text-xs font-medium text-zinc-400"><Circle className="h-3.5 w-3.5" />Not planned</span>
                    )}
                  </div>
                ))}
              </div>
            )}
          </div>
          {onPlan && (
            <Button className="w-full" onClick={() => onPlan(fest)} data-testid="plan-content-button">
              <CalendarPlus className="mr-2 h-4 w-4" />Plan Content for this Day
            </Button>
          )}
        </div>
      </DialogContent>
    </Dialog>
  );
}
